import { useState } from 'react';
import { motion } from 'motion/react';
import { snappyTween } from './motionUi';

const MAX_LEN = 24;

export default function GameNicknameModal({ initialNickname = 'Alex', onSave, onBack, busy = false }) {
  const [value, setValue] = useState(initialNickname);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (trimmed.length < 2) {
      setError('At least 2 characters.');
      return;
    }
    if (trimmed.length > MAX_LEN) {
      setError(`Max ${MAX_LEN} characters.`);
      return;
    }
    setError('');
    onSave?.(trimmed);
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="space-y-4 p-5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
    >
      <div>
        <label htmlFor="game-nickname" className="mb-1.5 block text-[10px] font-semibold uppercase tracking-wide text-game-muted">
          Display name
        </label>
        <motion.input
          id="game-nickname"
          type="text"
          value={value}
          maxLength={MAX_LEN}
          onChange={(e) => {
            setValue(e.target.value);
            setError('');
          }}
          className="w-full rounded-xl border border-white/15 bg-game-surface px-3 py-2.5 text-sm text-game-text placeholder:text-game-muted focus:border-game-accent/50 focus:outline-none focus:ring-1 focus:ring-game-accent/40 disabled:opacity-50"
          placeholder="Enter nickname"
          whileFocus={{ scale: busy ? 1 : 1.01 }}
          transition={{ type: 'spring', stiffness: 400, damping: 30 }}
        />
        <p className="mt-1 text-right text-[10px] text-game-muted">
          {value.length}/{MAX_LEN}
        </p>
        {error ? <p className="mt-1 text-xs text-red-400">{error}</p> : null}
      </div>
      <div className="flex gap-2 pt-1">
        {onBack ? (
          <motion.button
            type="button"
            transition={snappyTween}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={onBack}
            disabled={busy}
            className="rounded-xl border border-white/15 bg-game-surface px-4 py-2.5 text-sm font-semibold text-game-text disabled:opacity-50"
          >
            Cancel
          </motion.button>
        ) : null}
        <motion.button
          type="submit"
          disabled={busy}
          transition={snappyTween}
          whileHover={{ scale: busy ? 1 : 1.02 }}
          whileTap={{ scale: busy ? 1 : 0.98 }}
          className={`rounded-xl bg-game-accent py-2.5 text-sm font-bold text-game-accentText disabled:opacity-50 ${onBack ? 'min-w-0 flex-1' : 'w-full'}`}
        >
          {busy ? 'Saving…' : 'Save'}
        </motion.button>
      </div>
    </motion.form>
  );
}
